import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useClienteService } from "@services/ClienteService";
import React from "react";

export enum EnumClienteTipo {
    None = "0",
    PessoaFisica = 1,
    PessoaJuridica = 2
}

export interface IClienteTipo {
    clienteTipoId: number
    nome: string
    ativo: string
}

export type IComboClienteTipo = ISpecializedCombo<IClienteTipo>;

export function useClienteTipoCombo (initialValue?: EnumClienteTipo) : IComboClienteTipo {
    const combo = useCombo<IClienteTipo>({
        value: initialValue
    });

    const clienteService = useClienteService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((clienteTipo, index) => {
            return <MenuItem key={index} value={clienteTipo.clienteTipoId}>{ clienteTipo.nome }</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(clienteService.listarTiposAtivos)
    }, [combo, clienteService.listarTiposAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

